import React, { useState } from 'react'
import { Dropdown, Space, Typography } from 'antd'
import { FormattedMessage, injectIntl } from 'react-intl'
import { DownOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

export const CourseCatalogDropdown = () => {

  return (
    <>
      <Dropdown menu={ { items: [
        {
          key: 'course-catalog',
          type: 'group',
          label: <FormattedMessage id='navigation.courseCatalog' />,
          children: [
            {
              key: 'courses-overview',
              label: (
                <Link to="/course-catalog">
                  <FormattedMessage id='navigation.courseCatalog.browseCourses' />
                </Link>
              )
            },
            {
              key: 'course',
              label: (
                <div>
                  <FormattedMessage id='navigation.courseCatalog.myBoughtCourses' />
                </div>
              )
            },
          ],
        },
      ]} }>
        <Space style={{ cursor: 'pointer'}}>
          <Typography.Title level={5} style={{ marginTop: '5px' }}>
            <FormattedMessage id='navigation.courseCatalog' />
          </Typography.Title>
          <DownOutlined />
        </Space>
      </Dropdown>
    </>
  )
}

export default injectIntl(CourseCatalogDropdown)